import { useRef, useState } from 'react'
import { Medias } from '../../../enumns/medias'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { useOnClickOutside } from '../../../hooks/useOnClickOutside'

type State = {
  isOpen: boolean
  onToggle: () => void
  onClose: () => void
}

type ColumnFilterMenuStateManagerProps = {
  children: (state: State) => JSX.Element
}

export const ColumnFilterMenuStateManager = ({
  children,
}: ColumnFilterMenuStateManagerProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const menuContainerRef = useRef(null)
  const isMinScreenWidthMD = useMediaQuery(`(min-width: ${Medias.MD}px)`)

  const onClose = () => setIsOpen(false)
  const onToggle = () => setIsOpen((prevState) => !prevState)

  useOnClickOutside(menuContainerRef, onClose, {
    enabledHandler: isMinScreenWidthMD
  })

  return (
    <div className="inline-flex" ref={menuContainerRef}>
      {children({ isOpen, onClose, onToggle })}
    </div>
  )
}
